import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../../lib/api';
import { getSessionId, saveUserParams, paramsFromLocation, readUserParams } from '../../lib/userParams';

export default function PageTracker() {
  const location = useLocation();
  const lastSent = useRef('');

  useEffect(() => {
    // Skip admin routes AND unsubscribe (hidden standalone page — no tracking)
    if (location.pathname.startsWith('/admin')) return;
    if (location.pathname === '/unsubscribe') return;
    // Merge & persist URL params
    const urlParams = paramsFromLocation(location.search);
    const merged = saveUserParams(urlParams);

    const sid = getSessionId();
    const key = `${sid}|${location.pathname}|${location.search}`;
    if (lastSent.current === key) return;
    lastSent.current = key;

    // Also update document title based on route
    const titles = {
      '/': 'The Loan Alliance – Compare. Choose. Save.',
      '/loan': 'Personal Loans – The Loan Alliance',
      '/protect-credit': 'Credit Protection – The Loan Alliance',
      '/build-credit': 'Financials & Wealth Builders – The Loan Alliance',
      '/how-it-works': 'How It Works – The Loan Alliance',
      '/faq': 'FAQ – The Loan Alliance',
      '/privacy-policy': 'Privacy Policy – The Loan Alliance',
    };
    document.title = titles[location.pathname] || 'The Loan Alliance';

    // Fire pageview (best-effort, non-blocking)
    api.post('/analytics/pageview', {
      session_id: sid,
      page: location.pathname,
      params: { ...merged, __search: location.search },
      referrer: document.referrer || '',
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}

export function useUserParams() {
  return readUserParams();
}
